export const newsList = [
  {
    id: "autumn-2025-guide",
    title: "火狼独家：2025秋季新番导视，三十部作品抢先看",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20colorful%20collage%20of%20autumn%20anime%20posters%20and%20characters%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20warm%20orange%20autumn%20toned%20background%2C%20dynamic%20energetic%20composition%2C%20clean%20editorial%20layout%2C%20high%20quality%20magazine%20cover%20style&width=800&height=500&seq=wolf-news-01&orientation=landscape",
    summary:
      "秋季档新番阵容空前强大，热血、治愈、科幻、恋爱多线齐发。火狼动漫网为你梳理三十部值得关注的新作，帮助你快速锁定本季必追清单。",
    content: [
      "随着十月番陆续开播，2025年秋季档被不少观众称为“近年最强季”。从王道热血到细腻治愈，从硬核科幻到甜蜜恋爱，本季度几乎覆盖了所有主流题材，让不同口味的观众都能找到心头好。",
      "在最受期待的作品中，《焰之纪元》第二季、《灵刃千机》新篇章以及《深海回响》均榜上有名。三部作品在开播前就凭借高质量的预告片累积了极高的话题度，开播首周便登上各大平台热度榜前列。",
      "值得注意的是，本季度国产动画的表现格外亮眼。除《灵刃千机》《苍穹剑歌》外，还有多部新作在美术风格与叙事节奏上展现出成熟水准，海外平台的预约量也创下新高。",
      "火狼动漫网编辑部建议，新番开播初期不必急着追完所有作品，可以先从预告片和staff阵容入手，挑选两三部真正感兴趣的作品追起来。我们也会持续更新每部作品的口碑与看点，帮你省下“踩雷”的时间。",
    ],
    category: "新番资讯",
    author: "火狼编辑部",
    source: "火狼动漫网",
    publishedAt: "2025-10-12 09:30",
    tags: ["秋季新番", "导视", "必追清单"],
  },
  {
    id: "yan-zhi-jiyuan-season2",
    title: "《焰之纪元》第二季正式定档，官方放出全新PV",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20fire%20warrior%20surrounded%20by%20blazing%20flames%20and%20dramatic%20lightning%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20epic%20battle%20energy%2C%20deep%20red%20and%20orange%20toned%20background%2C%20dynamic%20composition%2C%20clean%20editorial%20layout%2C%20high%20quality%20magazine%20cover%20style&width=800&height=500&seq=wolf-news-02&orientation=landscape",
    summary:
      "万众期待的《焰之纪元》第二季终于定档，官方同步公开了时长两分钟的全新PV，新角色与新舞台首度亮相，瞬间点燃了粉丝的热情。",
    content: [
      "在昨日举行的线上发布会中，《焰之纪元》官方正式宣布第二季将于本季度开播，并放出了备受关注的全新预告片。短短两分钟内，大量高帧率打斗镜头与全新场景接连出现。",
      "新PV中最令观众惊喜的，是数位此前从未登场的新角色首次曝光。从角色设计来看，第二季的阵营格局将比第一季更加复杂，主角凛的成长也会遭遇前所未有的考验。",
      "制作方在采访中透露，第二季在动作分镜上投入了比首季更多的资源，并邀请了多位资深原画师加盟。“我们希望观众能感受到焰之力量的重量与代价。”主创如是表示。",
      "随着定档消息公布，相关话题迅速登上社交平台热搜。火狼动漫网也将持续跟进后续情报，为读者带来第一手的作品资讯。",
    ],
    category: "作品动态",
    author: "火狼编辑部",
    source: "火狼动漫网",
    publishedAt: "2025-10-10 18:05",
    tags: ["焰之纪元", "第二季", "PV"],
  },
  {
    id: "shen-hai-hui-xiang-award",
    title: "《深海回响》获年度最佳剧情动画提名",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20underwater%20glowing%20ruins%20with%20light%20rays%20and%20silhouette%20of%20a%20diver%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20mysterious%20deep%20blue%20toned%20background%2C%20cinematic%20atmosphere%2C%20clean%20editorial%20layout%2C%20high%20quality%20magazine%20cover%20style&width=800&height=500&seq=wolf-news-03&orientation=landscape",
    summary:
      "凭借扎实的剧本与独特的美术风格，《深海回响》成功入围年度最佳剧情动画，成为本届评选中最大的黑马之一。",
    content: [
      "年度动画评选的入围名单于近日公布，《深海回响》赫然出现在最佳剧情动画的提名之列。作为一部开播前并不被广泛看好的作品，它的逆袭让人颇感意外。",
      "评委在点评中提到，《深海回响》在叙事结构上层层递进，配合极具沉浸感的声音设计，营造出了一种“被大海包裹”的独特氛围，这在近年的作品中并不多见。",
      "观众口碑方面，该作在多个评分平台保持在高分区间，“越看越上头”“伏笔回收得漂亮”成为评论区的高频词。许多观众表示，这是本季度最适合一口气连看的作品。",
      "本届评选的最终结果将于下月揭晓，火狼动漫网将持续关注并带来最新报道。",
    ],
    category: "行业动态",
    author: "火狼编辑部",
    source: "火狼动漫网",
    publishedAt: "2025-10-08 11:20",
    tags: ["深海回响", "年度评选", "剧情动画"],
  },
  {
    id: "clocktower-remake",
    title: "经典IP《时钟塔的少女》宣布重制，预计明年上线",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20giant%20vintage%20clock%20tower%20with%20glowing%20gears%20and%20golden%20light%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20steampunk%20fantasy%20atmosphere%2C%20warm%20amber%20toned%20background%2C%20clean%20editorial%20layout%2C%20high%20quality%20magazine%20cover%20style&width=800&height=500&seq=wolf-news-04&orientation=landscape",
    summary:
      "曾感动无数观众的经典作品《时钟塔的少女》正式宣布推出重制版，采用全新作画与配乐，预计将于明年与观众见面。",
    content: [
      "在许多观众心中，《时钟塔的少女》是“时间题材”动画里难以绕过的经典。如今，官方正式宣布将推出重制版本，消息一出便引发广泛讨论。",
      "据官方介绍，重制版并非简单的高清修复，而是会采用全新的作画规格与重新录制的配乐，同时保留原作的叙事精髓。“我们希望在尊重原作的基础上，让新一代观众也能感受到它的魅力。”制作人表示。",
      "对于许多老观众而言，最关心的莫过于经典名场面能否被妥善呈现。官方回应称，几场关键戏份将会以更细腻的方式重新演绎，同时保留原有的情感内核。",
      "重制版预计明年上线，火狼动漫网将持续跟进相关情报。",
    ],
    category: "作品动态",
    author: "火狼编辑部",
    source: "火狼动漫网",
    publishedAt: "2025-10-05 15:40",
    tags: ["时钟塔的少女", "重制", "经典IP"],
  },
  {
    id: "ling-ren-qian-ji-overseas",
    title: "国产动画《灵刃千机》海外播放量破亿",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20chinese%20swordsman%20with%20glowing%20spirit%20blade%20and%20ink%20energy%20ribbons%2C%20vibrant%20cel-shaded%20donghua%20art%20style%2C%20red%20and%20gold%20dramatic%20lighting%2C%20epic%20chinese%20ink%20painting%20atmosphere%2C%20clean%20editorial%20layout%2C%20high%20quality%20magazine%20cover%20style&width=800&height=500&seq=wolf-news-05&orientation=landscape",
    summary:
      "《灵刃千机》海外平台累计播放量正式突破一亿大关，成为近年来出海表现最亮眼的国产动画之一。",
    content: [
      "国产动画《灵刃千机》再传捷报，其海外平台的累计播放量正式突破一亿次。这一成绩不仅刷新了该作自身的纪录，也让它成为近年国产动画出海的代表案例。",
      "从观众反馈来看，《灵刃千机》最具辨识度的，是其将水墨美学融入打斗戏的表现手法。流畅的动作设计与东方审美的结合，让不少海外观众对“中式武侠动画”产生了浓厚兴趣。",
      "有海外媒体评论称，该作在保持类型爽感的同时，也塑造出了有血有肉的角色群像，这是它能够在不同文化背景的观众中都收获喜爱的关键。",
      "随着口碑的持续发酵，该作的后续剧情也备受期待。火狼动漫网将持续关注国产动画的出海动态。",
    ],
    category: "行业动态",
    author: "火狼编辑部",
    source: "火狼动漫网",
    publishedAt: "2025-10-03 10:15",
    tags: ["灵刃千机", "国产动画", "出海"],
  },
  {
    id: "seiyuu-tour",
    title: "声优见面会巡演开启，多部热门作品主创齐聚",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20bright%20anime%20fan%20event%20stage%20with%20spotlights%2C%20microphones%20and%20colorful%20banners%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20festive%20energetic%20atmosphere%2C%20warm%20colorful%20background%2C%20clean%20editorial%20layout%2C%20high%20quality%20magazine%20cover%20style&width=800&height=500&seq=wolf-news-06&orientation=landscape",
    summary:
      "一场横跨多城的声优见面会巡演即将开启，多部热门作品的配音阵容将亲临现场，与粉丝进行近距离互动。",
    content: [
      "由多家制作公司联合举办的声优见面会巡演即将拉开帷幕，本次巡演将覆盖多座城市，邀请《焰之纪元》《樱色恋歌》等多部热门作品的主要配音演员登台。",
      "主办方透露，见面会除了惯例的问答与互动环节外，还特别准备了现场配音表演，让观众有机会近距离感受声音的魅力。部分场次还将首播未公开的角色特辑。",
      "门票预售开启后迅速售罄，不少粉丝在社交平台表示“抢票比追番还紧张”。主办方提醒观众留意官方渠道，谨防非正规渠道的加价售票。",
      "火狼动漫网将为读者持续更新巡演的场次与最新情报，敬请关注。",
    ],
    category: "活动资讯",
    author: "火狼编辑部",
    source: "火狼动漫网",
    publishedAt: "2025-09-30 20:00",
    tags: ["声优", "见面会", "线下活动"],
  },
  {
    id: "cat-town-crowdfunding",
    title: "《猫町奇谭》周边众筹超额完成，第三季呼声高涨",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20cute%20cat%20merchandise%20plushies%20and%20keychains%20on%20a%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20playful%20cheerful%20atmosphere%2C%20soft%20pastel%20colorful%20background%2C%20clean%20editorial%20layout%2C%20high%20quality%20magazine%20cover%20style&width=800&height=500&seq=wolf-news-07&orientation=landscape",
    summary:
      "《猫町奇谭》官方周边众筹在上线后迅速突破目标金额，超额完成的成绩让粉丝对第三季的期待值不断攀升。",
    content: [
      "以治愈搞笑风格走红的《猫町奇谭》，其官方周边众筹项目在开启后不久便达成了初始目标，随后更是一路飙升，最终以远超预期的成绩收官。",
      "本次众筹推出的猫咪主题玩偶与生活周边受到粉丝热捧，多款商品在上线当天便被抢购一空。有粉丝笑称：“钱包是猫猫们负责掏空的。”",
      "众筹的成功也让不少观众更加期待作品的后续发展。虽然官方尚未正式宣布第三季的消息，但在评论区与社交平台上，“求第三季”的呼声已经此起彼伏。",
      "火狼动漫网将持续关注该作的后续动向。",
    ],
    category: "作品动态",
    author: "火狼编辑部",
    source: "火狼动漫网",
    publishedAt: "2025-09-27 14:25",
    tags: ["猫町奇谭", "众筹", "周边"],
  },
  {
    id: "annual-award-nominations",
    title: "动画界大奖公布入围名单，多部新作榜上有名",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20golden%20trophy%20and%20film%20reels%20with%20sparkling%20light%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20celebratory%20ceremony%20atmosphere%2C%20deep%20blue%20and%20gold%20toned%20background%2C%20clean%20editorial%20layout%2C%20high%20quality%20magazine%20cover%20style&width=800&height=500&seq=wolf-news-08&orientation=landscape",
    summary:
      "年度动画大奖入围名单正式揭晓，从热血王道到细腻治愈，多部新作与口碑佳作共同角逐各大奖项。",
    content: [
      "备受关注的年度动画大奖于本周公布了完整入围名单。本届评选共设置十余个奖项，涵盖剧本、作画、音乐、角色设计等多个维度。",
      "在最佳作品奖项中，既有《星海彼端的信》这样的口碑完结作，也有《灵刃千机》《焰之纪元》等仍在热播的新作，竞争相当激烈。此外，多部小成本佳作也凭借扎实的质量获得了提名。",
      "业内人士分析，本届入围名单的一个显著特点，是题材的多元化程度较往年明显提升。无论是硬核科幻还是日常治愈，都得到了评审的认可。",
      "最终获奖名单将在颁奖典礼现场揭晓，火狼动漫网将带来第一时间的报道。",
    ],
    category: "行业动态",
    author: "火狼编辑部",
    source: "火狼动漫网",
    publishedAt: "2025-09-24 09:00",
    tags: ["年度大奖", "入围名单", "行业动态"],
  },
  {
    id: "jifeng-interview",
    title: "《疾风竞速》原作者专访：想画出最纯粹的热血",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20dynamic%20cyclist%20racing%20with%20speed%20lines%20and%20sunset%20light%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20passionate%20energetic%20atmosphere%2C%20warm%20orange%20toned%20background%2C%20clean%20editorial%20layout%2C%20high%20quality%20magazine%20cover%20style&width=800&height=500&seq=wolf-news-09&orientation=landscape",
    summary:
      "在《疾风竞速》热度持续走高之际，原作者接受了火狼动漫网的独家专访，畅谈创作初衷与对“热血”的理解。",
    content: [
      "“我想画的，不是天才的胜利，而是普通人不肯认输的那口气。”这是《疾风竞速》原作者在专访中反复提到的一句话。",
      "谈及创作初衷，作者表示自己从小便喜欢自行车运动，那种迎着风前进、腿酸到极限却仍想再踩一脚的感觉，正是他想要传递的东西。因此在作品中，主角并非天赋异禀的天才，而是靠坚持一步步向前的人。",
      "对于动画化的改编，作者给予了高度评价，称制作组“把速度感做出了灵魂”。他也坦言，看到自己笔下的角色真正“动起来”时，内心非常感动。",
      "当被问到对观众想说的话时，作者笑着说：“希望每个追这部番的人，都能在生活里找到属于自己的那次冲刺。”",
    ],
    category: "活动资讯",
    author: "火狼编辑部",
    source: "火狼动漫网",
    publishedAt: "2025-09-20 16:50",
    tags: ["疾风竞速", "专访", "原作者"],
  },
];